import React from 'react';
import VeltCommentsSidebarFilterAllOption from './VeltCommentsSidebarFilterAllOption/VeltCommentsSidebarFilterAllOption';
import VeltCommentsSidebarFilterCategory from './VeltCommentsSidebarFilterCategory/VeltCommentsSidebarFilterCategory';
import VeltCommentsSidebarFilterCheckbox from './VeltCommentsSidebarFilterCheckbox/VeltCommentsSidebarFilterCheckbox';
import VeltCommentsSidebarFilterCloseButton from './VeltCommentsSidebarFilterCloseButton/VeltCommentsSidebarFilterCloseButton';
import VeltCommentsSidebarFilterCommentType from './VeltCommentsSidebarFilterCommentType/VeltCommentsSidebarFilterCommentType';
import VeltCommentsSidebarFilterDoneButton from './VeltCommentsSidebarFilterDoneButton/VeltCommentsSidebarFilterDoneButton';
import VeltCommentsSidebarFilterGroupBy from './VeltCommentsSidebarFilterGroupBy/VeltCommentsSidebarFilterGroupBy';
import VeltCommentsSidebarFilterLocation from './VeltCommentsSidebarFilterLocation/VeltCommentsSidebarFilterLocation';
import VeltCommentsSidebarFilterPeople from './VeltCommentsSidebarFilterPeople/VeltCommentsSidebarFilterPeople';
import VeltCommentsSidebarFilterPriority from './VeltCommentsSidebarFilterPriority/VeltCommentsSidebarFilterPriority';
import VeltCommentsSidebarFilterTitle from './VeltCommentsSidebarFilterTitle/VeltCommentsSidebarFilterTitle';
import VeltCommentsSidebarFilterVersions from './VeltCommentsSidebarFilterVersions/VeltCommentsSidebarFilterVersions';
var VeltCommentsSidebarFilter = function (props) {
    var children = props.children;
    return (React.createElement("velt-comments-sidebar-filter-wireframe", null, children));
};
VeltCommentsSidebarFilter.AllOption = VeltCommentsSidebarFilterAllOption;
VeltCommentsSidebarFilter.Category = VeltCommentsSidebarFilterCategory;
VeltCommentsSidebarFilter.Checkbox = VeltCommentsSidebarFilterCheckbox;
VeltCommentsSidebarFilter.CloseButton = VeltCommentsSidebarFilterCloseButton;
VeltCommentsSidebarFilter.CommentType = VeltCommentsSidebarFilterCommentType;
VeltCommentsSidebarFilter.DoneButton = VeltCommentsSidebarFilterDoneButton;
VeltCommentsSidebarFilter.GroupBy = VeltCommentsSidebarFilterGroupBy;
VeltCommentsSidebarFilter.Location = VeltCommentsSidebarFilterLocation;
VeltCommentsSidebarFilter.People = VeltCommentsSidebarFilterPeople;
VeltCommentsSidebarFilter.Priority = VeltCommentsSidebarFilterPriority;
VeltCommentsSidebarFilter.Title = VeltCommentsSidebarFilterTitle;
VeltCommentsSidebarFilter.Versions = VeltCommentsSidebarFilterVersions;
export default VeltCommentsSidebarFilter;
